module.exports = __webpack_public_path__ + "static/media/advasonic-toothbrush-head-4.010aac13.jpg";